import { hoursToMilliseconds, millisecondsToHours, millisecondsToMinutes } from 'date-fns';

/** Fixed 24 h day (not calendar); matches date-fns hour helpers. */
const MS_PER_DAY = hoursToMilliseconds(24);

/**
 * Formats elapsed milliseconds as day / hour / minute chunks (fixed 24 h days; not calendar).
 * Seconds are truncated (not shown). Example: "85 days 20h 30m"
 */
export function formatMillisecondsAsDayHourMinSec(ms: number): string {
    if (isNaN(ms)) {
        return '—';
    }
    const total = Math.max(0, Math.floor(ms));
    const days = Math.floor(total / MS_PER_DAY);
    let remainder = total % MS_PER_DAY;

    const hours = millisecondsToHours(remainder);
    remainder -= hoursToMilliseconds(hours);

    const minutes = millisecondsToMinutes(remainder);

    if (total === 0) {
        return '0m';
    }

    const parts: string[] = [];
    if (days > 0) {
        parts.push(`${days} days`);
    }
    if (hours > 0 || parts.length > 0) {
        parts.push(`${hours}h`);
    }
    if (minutes > 0 || parts.length > 1) {
        parts.push(`${minutes}m`);
    }
    if (parts.length === 0) {
        return '< 1m';
    }

    return parts.join(' ');
}

// Transform the date format to ISO 8601 before parsing
// From: "2025-07-30 20:58:40.302707 +0000 UTC"
// To: "2025-07-30T20:58:40.302707Z"
export const transformToISO = (dateStr: string) => {
    if (!dateStr) return dateStr;

    // Replace space with T and remove timezone info, add Z for UTC
    return dateStr
        .replace(' ', 'T') // Replace first space with T
        .replace(/ \+0000 UTC$/, 'Z') // Replace " +0000 UTC" with "Z"
        .replace(/ UTC$/, 'Z'); // Fallback: replace " UTC" with "Z"
};
